import type {
  IndexPlatformStocksInput,
  PaginatedPlatformStocks,
  PlatformStockLog,
  PlatformStockProductOption,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export type FetchPlatformStocksParams = IndexPlatformStocksInput

export const fetchPlatformStocks = async (params?: FetchPlatformStocksParams) => {
  const response = await gozokiApiWithAuth.get<PaginatedPlatformStocks>('/platform-stocks', {
    params,
  })
  return response.data
}

export const fetchPlatformStockLogs = async (id: number, limit?: number) => {
  const response = await gozokiApiWithAuth.get<PlatformStockLog[]>(`/platform-stocks/${id}/logs`, {
    params: limit ? { limit } : undefined,
  })
  return response.data
}

export interface FetchDistinctPlatformStockProductsParams {
  storeReference?: string
  internalCategoryIds?: number[]
}

export const fetchDistinctPlatformStockProducts = async (
  params?: FetchDistinctPlatformStockProductsParams,
) => {
  const response = await gozokiApiWithAuth.get<PlatformStockProductOption[]>(
    '/platform-stocks/distinct-products',
    { params },
  )
  return response.data
}

export interface FetchDistinctPlatformStockLotsParams {
  storeReference?: string
  internalCategoryIds?: number[]
  search?: string
}

export const fetchDistinctPlatformStockLots = async (
  params?: FetchDistinctPlatformStockLotsParams,
) => {
  const response = await gozokiApiWithAuth.get<string[]>('/platform-stocks/distinct-lots', {
    params,
  })
  return response.data
}
